import React from 'react';
import './Service.css';

import { renderIcon } from '../../utils';  // Utility function to render service icon

import { Link } from 'react-router-dom';  // Link component to navigate to different pages
import { useTranslation } from 'react-i18next';  // Hook for translations

import { serviceTitle } from '../../constants';  // Import service title constants

const Service = (props) => {
  const { t } = useTranslation();  // Initialize translation hook

  // Destructuring props to extract the necessary details for each service
  const { id, image, title, service, content, icon } = props;

  return (

    <div className='service-item' key={id}>

      <img src={image} alt={t(title)} />{/* Service Image */}

      <div className='content'>

        <div className='icon'>{icon}</div> {/* Display the service icon based on title */}

        {/* Link to the individual service page */}
        <Link
          to={`/Uslugi/${id}`}
          state= {service}> 
          <h3>{t(title)}</h3> {/* Service Title */}
        </Link>

        <p>{t(content)}</p> {/* Service Description */}

        {/* Read more link to navigate to the full service page */}
        <Link
          to={`/Uslugi/${id}`}
          className='btn'  // Apply button style
          state={service}>{t(serviceTitle.moreInfoKey)}
        </Link>  {/* Button to read more about the service */}

      </div>

    </div>

  );
};

export default Service;